// import React from "react";
// import {
//   Box,
//   Button,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Typography,
// } from "@mui/material";
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import styles from "./Sidebar.module.css";
// import logo1 from "../../assets/images/GutBuddy1.png";
// import GroupIcon from "@mui/icons-material/Group";
// import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
// import PsychologyIcon from "@mui/icons-material/Psychology";
// import RssFeedIcon from "@mui/icons-material/RssFeed";
// import LiveHelpIcon from "@mui/icons-material/LiveHelp";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import LandscapeIcon from "@mui/icons-material/Landscape";
// import LayersIcon from "@mui/icons-material/Layers";
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import EventNoteIcon from '@mui/icons-material/EventNote';
// import FactCheckIcon from '@mui/icons-material/FactCheck';
// import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
// import FeedbackIcon from '@mui/icons-material/Feedback';
// import InsightsIcon from '@mui/icons-material/Insights';
// import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
// import BookIcon from '@mui/icons-material/Book';
// import DoctorImg from "../../assets/images/medical-assistance.svg"; // Import the DoctorImg SVG
// export const sidebarListArr = [
//   { label: "Patient List", icon: <GroupIcon />, url: "/Patient" },
//   { label: "Doctor List", imageIcon: DoctorImg, url: "/doctor" }, // Update for DoctorImg
//   {label:  "Doctor Speciality", icon: <InsightsIcon />, url: "/doctorspeciality" },
//   {label:  "In Person Appointment", icon: <BookIcon />, url: "/inpersonappointment" },
//   { label: "Diet Content", icon: <DinnerDiningIcon />, url: "/diet" },
//   { label: "Gut Content", icon: <PsychologyIcon />, url: "/brain" },
//   { label: "Learn Content", icon: <RssFeedIcon />, url: "/blogContnent" },
//   { label: "FAQ", icon: <LiveHelpIcon />, url: "/faq" },
//   { label: "Test Reports", icon: <SummarizeIcon />, url: "/reports" },
//   { label: "Diet Categories", icon: <LandscapeIcon />, url: "/dietcategories" },
//   { label: "Gut Categories", icon: <LayersIcon />, url: "/gutcategories" },
//   { label: "Learn Categories", icon: <DashboardIcon />, url: "/blogcategories" },
//   { label: "Learn Sub Categories", icon: <EventNoteIcon />, url: "/blogsubcategories" },
//   { label: "Diet Sub Categories", icon: <FactCheckIcon />, url: "/dietsubcategories" },
//   { label: "Gut Sub Categories", icon: <FeaturedPlayListIcon />, url: "/gutsubcategories" },
//   { label: "Yoga Module", icon: <SelfImprovementIcon />, url: "/yogamodule" },
//   { label: "User Feedback", icon: <FeedbackIcon />, url: "/feedback" },
// ];
// const Sidebar = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   console.log("location", location.pathname);
//   const logoutHandler = () => {
//     localStorage.removeItem("token");
//     navigate("/login");
//   };
//   return (
//     <Box className={styles.main_div}>
//       <Box className={styles.logo_content}>
//       <Box className={styles.header_div}>
//         <img src={logo1} alt="logo" className={styles.logo} />
//       </Box>
//       {/* <Typography className={styles.logo_heading}>GUT-BUDDY</Typography> */}
//       </Box>
//       <List className={styles.list_div}>
//         {sidebarListArr.map((val, index) => (
//           <div
//             key={index}
//             className={
//               location.pathname === val?.url
//                 ? styles.active_icon
//                 : styles.inactive_icon
//             }
//           >
//             <NavLink
//               to={`${val.url}`}
//               style={{ textDecoration: "none", color: "darkgray" }}
//             >
//               <ListItem button key={val.label}>
//                 <ListItemIcon color="inherit" className={styles.icon_css}>
//                   {/* Render the icon or imageIcon */}
//                   {val.icon ? (
//                     val.icon
//                   ) : (
//                     <img
//                       src={val.imageIcon}
//                       alt={val.label}
//                       style={{ width: "24px", height: "24px" }}
//                     />
//                   )}
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={val.label}
//                   className={
//                     location.pathname === val?.url
//                       ? styles.active_url_text
//                       : styles.inactive_url_text
//                   }
//                 />
//               </ListItem>
//             </NavLink>
//           </div>
//         ))}
//       </List>
//       <Box className={styles.logout_div}>
//         <Button
//           onClick={logoutHandler}
//           variant="contained"
//           className={styles.logout_btn}
//         >
//           logout
//         </Button>
//       </Box>
//     </Box>
//   );
// };
// export default Sidebar;


import React, { useState } from "react";
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Collapse,
} from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styles from "./Sidebar.module.css";
import logo1 from "../../assets/images/GutBuddy2.svg";

import GroupIcon from "@mui/icons-material/Group";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import PsychologyIcon from "@mui/icons-material/Psychology";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import SummarizeIcon from "@mui/icons-material/Summarize";
import LandscapeIcon from "@mui/icons-material/Landscape";
import LayersIcon from "@mui/icons-material/Layers";
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import FeedbackIcon from '@mui/icons-material/Feedback';
import InsightsIcon from '@mui/icons-material/Insights';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import BookIcon from '@mui/icons-material/Book';
import DoctorImg from "../../assets/images/medical-assistance.svg"; // Import the DoctorImg SVG
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PremiumIcon from '@mui/icons-material/Workspaces';

import WebIcon from '@mui/icons-material/Web';
import LanguageIcon from '@mui/icons-material/Language';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import QueryStatsIcon from "@mui/icons-material/QueryStats"; // More relevant icon for "Score Enquiry"
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import RateReviewIcon from '@mui/icons-material/RateReview';
import MovieIcon from '@mui/icons-material/Movie';
import ArticleIcon from '@mui/icons-material/Article';
import GroupsIcon from '@mui/icons-material/Groups';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import CreateIcon from '@mui/icons-material/Create';
import ChatIcon from '@mui/icons-material/Chat';

// Premium modules configuration
const premiumModules = [
  {
    label: "Yoga Module",
    icon: <SelfImprovementIcon />,
    url: "/yogamodule",
    subModules: [
      { label: "Yoga", url: "/yogamodule" },
      // Add more yoga-related submodules here
    ]
  },
  {
    label: "In-person Module",
    icon: <BookIcon />,
    url: "/inpersonappointment",
    subModules: [
      { label: "In-person Appointment", url: "/inpersonappointment" },
    ]
  },
  // Add more premium modules as needed
];

// Webiste Management modules configuration
const websiteModules = [
  {
    label: "Home Page",
    icon: <HomeIcon />,
    url: "/homepage",
    subModules: [
      { label: "Home Page", url: "/homepage" },
      { label: "Upload Videos", url: "/uploadvideo" },
      { label: "Carousel", url: "/homepage/carousel" },
      { label: "Brand Logos", url: "/homepage/brand-logos" },
    ]
  },
  {
    label: "About Page",
    icon: <InfoIcon />,
    url: "/aboutpage",
    subModules: [
      { label: "Upload Videos", url: "/about/uploadvideos" },
      { label: "Upload Logos", url: "/about/uploadlogos" },
      { label: "Hero Section", url: "/about/herosection" },
    ]
  },
  {
    label: "User Queries",
    icon: <HelpOutlineIcon />,
    url: "/userqueries",
    subModules: [
      { label: "User Queries", url: "/userqueries" },
    ]
  },
  {
    label: "Score Enquiry",
    icon: <QueryStatsIcon />, // Updated icon
    url: "/gut-score-enquiry",
    subModules: [
      { label: "Score Enquiry", url: "/gut-score-enquiry" },
    ],
  },
  {
    label: "Enroll Doctor",
    icon: <PersonAddIcon />,
    url: "/enrolldoctor",
    subModules: [
      { label: "Enroll Doctor", url: "/enrolldoctor" },
    ]
  },
  {
    label: "Testimonial",
    icon: <RateReviewIcon />,
    url: "/usertestimonial",
    subModules: [
      { label: "User Testimonial", url: "/usertestimonial" },
      { label: "Doctor Testimonial", url: "/doctortestimonial" },
    ]
  },
  {
    label: "Blogs",
    icon: <ArticleIcon />,
    url: "/blogs",
    subModules: [
      { label: "Manage Blogs", url: "/blogs" },
      { label: "Webinar Events", url: "/webinarevents" },
    ]
  },
  {
    label: "Teams",
    icon: <GroupsIcon />,
    url: "/teams",
    subModules: [
      { label: "Manage Teams", url: "/teams" },
    ]
  },
  {
    label: "Q&A",
    icon: <QuestionAnswerIcon />,
    url: "/q&a",
    subModules: [
      { label: "Manage Q&A", url: "/q&a" },
    ]
  }
  // Add more website modules as needed
];

// Define CBT separately for the dropdown
const cbtModule = {
  label: "CBT",
  icon: <HelpOutlineIcon />,
  subModules: [
    { label: "CBT Question", url: "/cbtquestion" },
    { label: "Dass Question", url: "/cbtdassquestion" },
    { label: "CBT Tasks", url: "/cbt-tasks" },
    // { label: "Task Management", url: "/cbt-task-management" },
    // { label: "Task Management (New)", url: "/cbt-task-management-new" },
    // { label: "User Task Assignment", url: "/user-task-assignment" },
    { label: "Prompt Management", url: "/prompts", icon: <CreateIcon /> },
    { label: "Session Summaries", url: "/cbt-session-summaries" },
    { label: "Journal Categories", url: "/journal-categories" },
    { label: "Journal Responses", url: "/journal-responses" },
    { label: "CBT Content", url: "/cbt-content" },
    // { label: "Patient Task Completion", url: "/patient-task-completion" },
  ]
};

// Define Diet module for the dropdown
const dietModule = {
  label: "Diet",
  icon: <DinnerDiningIcon />,
  subModules: [
    { label: "Diet Content", url: "/diet" },
    { label: "Diet Meal Plan", url: "/DietMealPlan" },
    { label: "Meal Plan Review", url: "/diet-meal-plan-review" },
    { label: "Master Food", url: "/MasterFood" },
    // { label: "Low FODMAP Diet", url: "/low-fodmap-diet" },
    // { label: "Low FODMAP Management", url: "/diet/low-fodmap" },
    // { label: "Testing Foods", url: "/diet/low-fodmap/testing-foods" },
    // { label: "Phase Prompts", url: "/diet/low-fodmap/prompts" },
    { label: "Diet Categories", url: "/dietcategories" },
    { label: "Diet Sub Categories", url: "/dietsubcategories" },
    { label: "Diet Prompts", url: "/diet-prompts" },
    // { label: "Diet Configurations", url: "/diet-configurations" },
    { label: "System Overview", url: "/diet-system-overview" },
    { label: "Diet Feedback", url: "/diet-feedback" },
  ]
};

export const sidebarListArr = [
  { label: "Dashboard", icon: <DashboardIcon />, url: "/dashboard" },
  { label: "Patient List", icon: <GroupIcon />, url: "/Patient" },
  { label: "Doctor List", imageIcon: <DoctorImg />, url: "/doctor" }, // Update for DoctorImg
  { label: "Doctor Speciality", icon: <InsightsIcon />, url: "/doctorspeciality" },
  // {label:  "In Person Appointment", icon: <BookIcon />, url: "/inpersonappointment" },
  { label: "Gut Content", icon: <PsychologyIcon />, url: "/brain" },
  { label: "Learn Content", icon: <RssFeedIcon />, url: "/blogContnent" },
  { label: "FAQ", icon: <LiveHelpIcon />, url: "/faq" },
  { label: "Test Reports", icon: <SummarizeIcon />, url: "/reports" },
  { label: "Gut Categories", icon: <LayersIcon />, url: "/gutcategories" },
  { label: "Learn Categories", icon: <DashboardIcon />, url: "/blogcategories" },
  { label: "Learn Sub Categories", icon: <EventNoteIcon />, url: "/blogsubcategories" },
  { label: "Gut Sub Categories", icon: <FeaturedPlayListIcon />, url: "/gutsubcategories" },
  // { label: "Yoga Module", icon: <SelfImprovementIcon />, url: "/yogamodule" },
  { label: "User Feedback", icon: <FeedbackIcon />, url: "/feedback" }
  // Removed Prompt Management from here
];

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [premiumOpen, setPremiumOpen] = useState(false);
  const [websiteOpen, setWebsiteOpen] = useState(false);
  const [openModules, setOpenModules] = useState({});
  const [cbtOpen, setCbtOpen] = useState(false);
  const [dietOpen, setDietOpen] = useState(false);


  // Modified to check if current path is part of premium modules
  const isPremiumPath = () => {
    return premiumModules.some(module =>
      location.pathname.startsWith(module.url) ||
      module.subModules.some(sub => location.pathname === sub.url)
    );
  };

  // Check if current path is part of website modules
  const isWebsitePath = () => {
    return websiteModules.some(module =>
      location.pathname === module.url ||
      (module.subModules && module.subModules.some(sub =>
        location.pathname === sub.url
      ))
    );
  };

  const isCBTPath = () => {
    return (
      location.pathname === cbtModule.url ||
      (cbtModule.subModules &&
        cbtModule.subModules.some(sub => location.pathname === sub.url))
    );
  };

  const isDietPath = () => {
    return (
      location.pathname === dietModule.url ||
      (dietModule.subModules &&
        dietModule.subModules.some(sub => location.pathname === sub.url))
    );
  };
  
  React.useEffect(() => {
    if (isCBTPath()) {
      setCbtOpen(true);
        setOpenModules(prev => ({
          ...prev,
          [cbtModule.label]: true
        }));
    }
  }, [location.pathname]);

  React.useEffect(() => {
    if (isDietPath()) {
      setDietOpen(true);
        setOpenModules(prev => ({
          ...prev,
          [dietModule.label]: true
        }));
    }
  }, [location.pathname]);
  
  // Keep premium dropdown open if current path is a premium path
  React.useEffect(() => {
    if (isPremiumPath()) {
      setPremiumOpen(true);
      // Find and open the relevant module
      premiumModules.forEach(module => {
        if (location.pathname.startsWith(module.url)) {
          setOpenModules(prev => ({
            ...prev,
            [module.label]: true
          }));
        }
      });
    }
  }, [location.pathname]);

  // Keep website dropdown open if current path is a website path
  React.useEffect(() => {
    if (isWebsitePath()) {
      setWebsiteOpen(true);
      websiteModules.forEach(module => {
        if (location.pathname === module.url ||
          (module.subModules && module.subModules.some(sub =>
            location.pathname === sub.url
          ))) {
          setOpenModules(prev => ({
            ...prev,
            [module.label]: true
          }));
        }
      });
    }
  }, [location.pathname]);

  const handlePremiumClick = () => {
    setPremiumOpen(!premiumOpen);
  };

  const handleWebsiteClick = () => {
    setWebsiteOpen(!websiteOpen);
  };

  const handleModuleClick = (moduleLabel) => {
    setOpenModules(prev => ({
      ...prev,
      [moduleLabel]: !prev[moduleLabel]
    }));
  };

  const logoutHandler = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  // Updated isActive function to do exact path matching
  const isActive = (path) => {
    // For root path, only match exactly
    if (path === '/') {
      return location.pathname === path;
    }

    // For all other paths, do exact matching
    return location.pathname === path;
  };
  return (
    <Box className={styles.main_div}>
      <Box className={styles.logo_content}>
        <Box className={styles.header_div}>
          <img src={logo1} alt="logo" className={styles.logo} />
        </Box>
      </Box>

      <List className={styles.list_div}>
        {/* Premium Dropdown */}
        <ListItem
          button
          onClick={handlePremiumClick}
          className={isPremiumPath() ? styles.active_icon : styles.inactive_icon}
        >
          <ListItemIcon className={styles.icon_css}>
            <PremiumIcon />
          </ListItemIcon>
          <ListItemText primary="Premium" />
          {premiumOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={premiumOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {premiumModules.map((module, index) => (
              <div key={index}>
                <ListItem
                  button
                  onClick={() => handleModuleClick(module.label, module.url)}
                  className={isActive(module.url) ? styles.active_icon : styles.inactive_icon}
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon className={styles.icon_css}>
                    {module.icon}
                  </ListItemIcon>
                  <ListItemText primary={module.label} />
                  {module.subModules?.length > 0 && (
                    openModules[module.label] ? <ExpandLess /> : <ExpandMore />
                  )}
                </ListItem>

                {module.subModules?.length > 0 && (
                  <Collapse in={openModules[module.label]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {module.subModules.map((subModule, subIndex) => (
                        <NavLink
                          key={subIndex}
                          to={subModule.url}
                          style={{ textDecoration: "none", color: "darkgray" }}
                        >
                          <ListItem
                            button
                            sx={{ pl: 6 }}
                            className={isActive(subModule.url) ? styles.active_icon : styles.inactive_icon}
                          >
                            <ListItemText primary={subModule.label} />
                          </ListItem>
                        </NavLink>
                      ))}
                    </List>
                  </Collapse>
                )}
              </div>
            ))}
          </List>
        </Collapse>

        {/* Website Dropdown */}
        <ListItem
          button
          onClick={handleWebsiteClick}
          className={isWebsitePath() ? styles.active_icon : styles.inactive_icon}
        >
          <ListItemIcon className={styles.icon_css}>
            {/* <WebIcon></WebIcon>  */}
            <LanguageIcon></LanguageIcon>
          </ListItemIcon>
          <ListItemText primary="Website" />
          {websiteOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={websiteOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {websiteModules.map((module, index) => (
              <div key={index}>
                <ListItem
                  button
                  onClick={() => handleModuleClick(module.label, module.url)}
                  className={isActive(module.url) ? styles.active_icon : styles.inactive_icon}
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon className={styles.icon_css}>
                    {module.icon}
                  </ListItemIcon>
                  <ListItemText primary={module.label} />
                  {module.subModules?.length > 0 && (
                    openModules[module.label] ? <ExpandLess /> : <ExpandMore />
                  )}
                </ListItem>

                {module.subModules?.length > 0 && (
                  <Collapse in={openModules[module.label]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {module.subModules.map((subModule, subIndex) => (
                        <NavLink
                          key={subIndex}
                          to={subModule.url}
                          style={{ textDecoration: "none", color: "darkgray" }}
                        >
                          <ListItem
                            button
                            sx={{ pl: 6 }}
                            className={isActive(subModule.url) ? styles.active_icon : styles.inactive_icon}
                          >
                            <ListItemText primary={subModule.label} />
                          </ListItem>
                        </NavLink>
                      ))}
                    </List>
                  </Collapse>
                )}
              </div>
            ))}
          </List>
        </Collapse>

            {/* CBT Dropdown */}
        <ListItem
          button
          onClick={() => handleModuleClick(cbtModule.label)}
          className={openModules[cbtModule.label] ? styles.active_icon : styles.inactive_icon}
        >
          <ListItemIcon className={styles.icon_css}>
            {cbtModule.icon}
          </ListItemIcon>
          <ListItemText primary="CBT" />
          {openModules[cbtModule.label] ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={openModules[cbtModule.label]} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {cbtModule.subModules.map((subModule, subIndex) => (
              <NavLink
                key={subIndex}
                to={subModule.url}
                style={{ textDecoration: "none", color: "darkgray" }}
              >
                <ListItem
                  button
                  sx={{ pl: 6 }}
                  className={isActive(subModule.url) ? styles.active_icon : styles.inactive_icon}
                >
                  <ListItemText primary={subModule.label} />
                </ListItem>
              </NavLink>
            ))}
          </List>
        </Collapse>

        {/* Diet Dropdown */}
        <ListItem
          button
          onClick={() => handleModuleClick(dietModule.label)}
          className={openModules[dietModule.label] ? styles.active_icon : styles.inactive_icon}
        >
          <ListItemIcon className={styles.icon_css}>
            {dietModule.icon}
          </ListItemIcon>
          <ListItemText primary="Diet" />
          {openModules[dietModule.label] ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={openModules[dietModule.label]} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {dietModule.subModules.map((subModule, subIndex) => (
              <NavLink
                key={subIndex}
                to={subModule.url}
                style={{ textDecoration: "none", color: "darkgray" }}
              >
                <ListItem
                  button
                  sx={{ pl: 6 }}
                  className={isActive(subModule.url) ? styles.active_icon : styles.inactive_icon}
                >
                  <ListItemText primary={subModule.label} />
                </ListItem>
              </NavLink>
            ))}
          </List>
        </Collapse>
        {/* Regular sidebar items */}
        {sidebarListArr.map((val, index) => (
          <div
            key={index}
            className={isActive(val.url) ? styles.active_icon : styles.inactive_icon}
          >
            <NavLink
              to={val.url}
              style={{ textDecoration: "none", color: "darkgray" }}
            >
              <ListItem button>
                <ListItemIcon className={styles.icon_css}>
                  {/* Render the icon or imageIcon */}
                  {val.icon ? (
                    val.icon
                  ) : (
                    <img
                      src={val.imageIcon.type}
                      alt={val.label}
                      style={{ width: "24px", height: "24px" }}
                    />
                  )
                  }

                </ListItemIcon>
                <ListItemText
                  primary={val.label}
                  className={isActive(val.url) ? styles.active_url_text : styles.inactive_url_text}
                />
              </ListItem>
            </NavLink>
          </div>
        ))}
      </List>

      <Box className={styles.logout_div}>
        <Button
          onClick={logoutHandler}
          variant="contained"
          className={styles.logout_btn}
        >
          logout
        </Button>
      </Box>
    </Box>
  );
};

export default Sidebar;
